import moment from 'moment'

const fixedTimePeriod = 12
// Default date range for fetching power prices for the widget. The widget uses a dynamic time frame of 24 hours.
export const fromDate = moment().subtract(fixedTimePeriod, 'hour').startOf('hour')
export const toDate = moment().add(fixedTimePeriod, 'hour')

// Default date range for fetching power prices for the modal. The modal uses time frame of 1 day.
export const fromDateForModal = moment().startOf('day')
export const toDateForModal = moment().add(1, 'day').endOf('day').startOf('hour')

/**
 * Compares two moment dates and returns the earlier one.
 * @param date1 one moment.Moment - Date
 * @param date2 other moment.Moment - Date
 * @returns The date, that is before the other one
 */
export const getEarlierDate = (date1: moment.Moment, date2: moment.Moment): moment.Moment => {
  return date1.isBefore(date2) ? date1 : date2
}

/**
 * Compares two moment dates and returns the later one.
 * @param date1 one moment.Moment - Date
 * @param date2 other moment.Moment - Date
 * @returns The date, that is after the other one
 */
export const getLaterDate = (date1: moment.Moment, date2: moment.Moment): moment.Moment => {
  return date1.isAfter(date2) ? date1 : date2
}
